import cn from 'classnames';
import React from 'react';

import style from './style.module.scss';

interface IPropsTable extends React.HTMLAttributes<any> {
  hasBorder?: boolean;
}

export const Table = (props: IPropsTable): React.ReactElement => {
  const { className, hasBorder, ...restProps } = props;
  return <table className={cn(className, style.table, cn({ [style.border]: hasBorder }))} {...restProps} />;
};
